var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vacancies-page nr_container_content " }, [
    _c("h1", { staticClass: "page-title" }, [
      _vm._v("\n        Ключевые вакансии\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-row" }, [
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c("v-text-field", {
            staticClass: "search-input",
            attrs: {
              "hide-details": "",
              solo: "",
              flat: "",
              placeholder: "Поиск вакансии",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "search-btn" },
            [
              _c("v-icon", { attrs: { color: "white" } }, [
                _vm._v("\n                    mdi-magnify\n                "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout" }, [
      _c("aside", { staticClass: "sidebar" }, [
        _c("div", { staticClass: "sidebar-header" }, [
          _c("div", { staticClass: "sidebar-title" }, [_vm._v("Фильтры")]),
          _vm._v(" "),
          _vm.isFilterActive
            ? _c(
                "button",
                { staticClass: "reset-btn", on: { click: _vm.resetFilters } },
                [
                  _vm._v(
                    "\n                    Сбросить фильтр\n                "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-section__wrapper" },
          _vm._l(_vm.filters, function (filter) {
            return _c(
              "div",
              { key: filter.id, staticClass: "filter-section" },
              [
                _c("div", { staticClass: "filter-section__title" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(filter.title) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                filter.type === "radio"
                  ? [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "radio-group",
                          attrs: { "hide-details": "" },
                          model: {
                            value: _vm.filterValues[filter.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.filterValues, filter.id, $$v)
                            },
                            expression: "filterValues[filter.id]",
                          },
                        },
                        _vm._l(filter.items, function (item) {
                          return _c("v-radio", {
                            key: item.value,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              color: "red",
                            },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                filter.type === "checkbox"
                  ? [
                      _vm._l(_vm.getVisibleItems(filter), function (item) {
                        return _c("v-checkbox", {
                          key: item.value,
                          staticClass: "checkbox-item",
                          attrs: {
                            value: item.value,
                            label: item.label,
                            "hide-details": "",
                            color: "red",
                          },
                          model: {
                            value: _vm.filterValues[filter.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.filterValues, filter.id, $$v)
                            },
                            expression: "filterValues[filter.id]",
                          },
                        })
                      }),
                      _vm._v(" "),
                      filter.showMore &&
                      filter.items.length > (filter.visibleCount || 5)
                        ? _c(
                            "button",
                            {
                              staticClass: "show-more",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleFilter(filter.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.expandedFilters[filter.id]
                                      ? "Скрыть"
                                      : "Показать еще"
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "vacancies-counter" }, [
            _vm._v(
              "\n                Найдено " +
                _vm._s(_vm.filteredVacancies.length) +
                " вакансий\n            "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.filteredVacancies, function (vacancy) {
            return _c(
              "div",
              {
                key: vacancy.id,
                staticClass: "vacancy-card position-relative",
              },
              [
                _c("a", {
                  staticClass: "position-absolute t-0 l-0 w-100 h-100 zi-1",
                  attrs: { href: vacancy.url },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "vacancy-meta" }, [
                  vacancy.city
                    ? _c("div", { staticClass: "meta-item" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "data-v-5d514390": "",
                                d: "M18.364 17.3639L12 23.7279L5.636 17.3639C4.37734 16.1052 3.52019 14.5016 3.17293 12.7558C2.82567 11.0099 3.00391 9.20035 3.6851 7.55582C4.36629 5.91129 5.51984 4.50569 6.99988 3.51677C8.47992 2.52784 10.22 2 12 2C13.78 2 15.5201 2.52784 17.0001 3.51677C18.4802 4.50569 19.6337 5.91129 20.3149 7.55582C20.9961 9.20035 21.1743 11.0099 20.8271 12.7558C20.4798 14.5016 19.6227 16.1052 18.364 17.3639ZM12 14.9999C13.0609 14.9999 14.0783 14.5785 14.8284 13.8283C15.5786 13.0782 16 12.0608 16 10.9999C16 9.93906 15.5786 8.92164 14.8284 8.17149C14.0783 7.42135 13.0609 6.99992 12 6.99992C10.9391 6.99992 9.92172 7.42135 9.17158 8.17149C8.42143 8.92164 8 9.93906 8 10.9999C8 12.0608 8.42143 13.0782 9.17158 13.8283C9.92172 14.5785 10.9391 14.9999 12 14.9999ZM12 12.9999C11.4696 12.9999 10.9609 12.7892 10.5858 12.4141C10.2107 12.0391 10 11.5304 10 10.9999C10 10.4695 10.2107 9.96078 10.5858 9.58571C10.9609 9.21064 11.4696 8.99992 12 8.99992C12.5304 8.99992 13.0391 9.21064 13.4142 9.58571C13.7893 9.96078 14 10.4695 14 10.9999C14 11.5304 13.7893 12.0391 13.4142 12.4141C13.0391 12.7892 12.5304 12.9999 12 12.9999Z",
                                fill: "#FA4237",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n\n                        " +
                            _vm._s(vacancy.city) +
                            "\n\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  vacancy.experience
                    ? _c("div", { staticClass: "meta-item" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              width: "20",
                              height: "18",
                              viewBox: "0 0 20 18",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M13 0C13.552 0 14 0.448 14 1V3H19C19.552 3 20 3.448 20 4V17C20 17.552 19.552 18 19 18H1C0.448 18 0 17.552 0 17V4C0 3.448 0.448 3 1 3H6V1C6 0.448 6.448 0 7 0H13ZM6 5H4V16H6V5ZM16 5H14V16H16V5ZM12 2H8V3H12V2Z",
                                fill: "#FA4237",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n\n\n                        " +
                            _vm._s(vacancy.experience) +
                            "\n\n                    "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vacancy-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(vacancy.title) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tags" },
                  _vm._l(vacancy.tags, function (tag) {
                    return _c("div", { key: tag, staticClass: "tag" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(tag) +
                          "\n                    "
                      ),
                    ])
                  }),
                  0
                ),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }